import * as types from './actionTypes';
import api from 'api/';

export function getData(storyname, id) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const cities = await api.getCities();
      const story = await api.getStory(storyname);
      const storyById = await api.getStoryID(story.data.id);
      const related = await api.getRelatedStory(story.data.id);
      const featured = await api.getFeaturedStory('Banglore', 'STORY');
      dispatch({
        type: types.LOADED,
        cities,
        story: story,
        related: related,
        featured: featured,
        storyById: storyById,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
